<template>
  <v-btn-form :title="title" @close="cancel()">
  <v-form v-model="valid" ref="form">
     <v-card-text>
      <div v-if="!isEdit">
        <v-layout row wrap>
          <v-text-field name="lastName" :value = "item.lastName" label="Фамилия" type="text" readonly disabled></v-text-field>
        </v-layout>
        <v-layout row wrap>
          <v-text-field name="firstName" :value = "item.firstName" label="Имя" type="text"  readonly disabled></v-text-field>
          <v-text-field name="middleName" :value = "item.middleName" label="Отчество" type="text"  readonly disabled></v-text-field>
        </v-layout>
         <v-layout row wrap>
          <v-text-field :value="item.clientEmail" name="clientEmail" label="Эл. почта рабочая" type="text" :rules="clientEmailRules" readonly></v-text-field>
          <v-text-field :value="item.clientPhone" :rules="phoneRules" name="clientPhone" label="Тел. рабочий" type="text" readonly></v-text-field>
         </v-layout>
         <v-layout row wrap>
          <v-text-field :value="item.roleNotes" name="roleNotes" label="Зоны ответственности в компании" type="text" readonly></v-text-field>
         </v-layout row wrap>
        <v-layout>
          <v-flex pa-0>
          <v-html-field label="Подпись в письмах" readonly :heightEditor="calcHeightEditor()" :value="item.signature"></v-html-field>
         </v-flex>
        </v-layout>
      </div>
      <div v-if="isEdit">
        <v-layout row wrap>
          <v-text-field v-show="isNew" v-model="username" label="Эл. почта зарегистрированного пользователя" type="text" :disabled="registerNew" hint="Введите адрес, используемый для входа в систему" persistent-hint :rules="emailRules" ></v-text-field>
        </v-layout>
        <v-checkbox v-model="registerNew"  v-show="isNew" label="Регистрировать нового пользователя" hide-details></v-checkbox>
        <v-layout row wrap>
          <v-text-field name="lastName" v-model = "item.lastName" label="Фамилия" type="text" :disabled="!registerNew" :rules="lastnameNotNullRule"></v-text-field>
        </v-layout>
        <v-layout row wrap>
          <v-text-field name="firstName" v-model = "item.firstName" label="Имя" type="text"  :disabled="!registerNew"></v-text-field>
          <v-text-field name="middleName" v-model = "item.middleName" label="Отчество" type="text"  :disabled="!registerNew"></v-text-field>
        </v-layout>
         <v-layout row wrap>
          <v-text-field v-model="item.clientEmail" name="clientEmail" label="Эл. почта рабочая" type="text" :rules="clientEmailRules"></v-text-field>
          <v-text-field v-model="item.clientPhone" :rules="phoneRules" name="clientPhone" label="Тел. рабочий" type="text" @change="onChangePhone(item, $event)"></v-text-field>
         </v-layout>
         <v-layout row wrap>
         <v-text-field v-model="item.roleNotes" name="roleNotes" label="Зоны ответственности в компании" type="text"></v-text-field>
          <v-flex xs12 md12 pa-0>
          <v-html-field label="Подпись в письмах" :heightEditor="calcHeightEditor()" name="signature" v-model="item.signature"></v-html-field>
          </v-flex>
        </v-layout>

      </div>
    </v-card-text>
  </v-form>
  <template #actions>
    <v-btn v-if="!isEdit" @click="edit=!edit" :disabled="!getIsAllow({AGENT_UPDATE: itemId})">Изменить</v-btn>
    <v-btn v-if="isEdit" v-show="!isNew" @click="save">Сохранить</v-btn>
    <v-btn v-if="isEdit" v-show="!isNew" :disabled="!getIsAllow({AGENT_DELETE: itemId})" @click="remove">Удалить</v-btn>
    <v-btn v-if="isEdit" v-show="isNew" :disabled='!valid' @click="add">Добавить</v-btn>
    <v-spacer></v-spacer>
    <v-btn v-if="isEdit" v-show="!isNew" :disabled="!getIsAllow({AGENT_RESET_PASSWORD: itemId})" @click="updatePassword">Сбросить пароль</v-btn>
  </template>
 </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import dialogs from '../common/dialogs'
  import forms from '../common/forms'
  import vCardScroll from '../common/CardScroll'
  import vHtmlField from '../common/HtmlField'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'client-agent-form',
    components: {vBtnForm, vCardScroll, vHtmlField},
    data: () => ({
      edit: false,
      valid: false,
      registerNew: false,
      username: null,
      item: {},
      phoneRules: [
        v => !v || formats.isPhone(formats.formatPhone(v)) || 'Формат номера +7(921)1234567'
      ]
    }),
    props: {
      itemId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.fetchClientUser(this.itemId)
      this.fetchRights()
    },
    mounted () {
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        this.fetchClientUser(newVal)
        this.fetchRights()
      },
      registerNew: function (newVal, oldVal) {
        if (newVal === true) {
          this.username = null
        }
      }
    },
    computed: {
      ...mapGetters({
        profile: 'getProfile',
        getIsAllow: 'getIsAllow',
        calcDialogScroll: 'calcDialogScroll'
      }),
      isEdit () {
        return this.edit || this.isNew
      },
      isNew () {
        return this.itemId === null
      },
      title () {
        return this.isNew ? 'Добавить представителя' : this.isEdit ? 'Изменить атрибуты' : 'Информация о представителе'
      },
      lastnameNotNullRule (name) {
        return this.registerNew ? [
          v => !!v || 'Введите фамилию'
        ] : []
      },
      emailRules () {
        return !this.registerNew ? [
          v => !!v || 'Введите адрес эл. почты, используемый для входа',
          v => formats.isEmail(v) || 'Неверный формат эл. почты'
        ] : []
      },
      clientEmailRules () {
        return !this.registerNew ? [
          v => !v || formats.isEmail(v) || 'Неверный формат эл. почты'
        ] : [
          v => !!v || 'Введите адрес корпоративной почты',
          v => formats.isEmail(v) || 'Неверный формат эл. почты'
        ]
      }
    },
    methods: {
      calcHeightEditor () {
        let height = Number.parseInt(this.calcDialogScroll(48 + 52), 10)
        if (Number.isNaN(height)) {
          return 0
        }
        return height * 0.4 + 'px'
      },
      onChangePhone (item, v) {
        item.clientPhone = formats.formatPhone(v)
      },
      add () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('addClientAgent', {username: this.username, dto: this.item})
          this.cancel()
        }
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      save () {
        this.$store.dispatch('updateClientAgent', this.item)
        this.edit = false
      },
      remove () {
        dialogs.confirm(this, 'Подтвердите', 'Удалить представителя компании?',
          (self) => {
            self.$store.dispatch('removeClientAgent', self.item)
            self.edit = false
            self.cancel()
          })
      },
      updatePassword () {
        dialogs.confirm(this, 'Подтвердите', 'Сбросить пароль?',
          (self) => {
            self.$store.dispatch('refreshAgentPassword', self.item)
            self.edit = false
          })
      },
      getItemNew () {
        return {
          clientInn: this.profile.clientInn,
          accountProfileId: null,
          firstName: null,
          middleName: null,
          lastName: null,
          clientPhone: null,
          clientEmail: null,
          clientRole: null,
          clientRoleNotes: null
        }
      },
      fetchClientUser (accountProfileId) {
        if (!!this.profile && !!this.profile.clientInn && !!accountProfileId) {
          server.apiGet(
            '/api/clients/' + this.profile.clientInn + '/agents/' + accountProfileId,
            (data) => {
              this.item = data
            },
            (e) => {
              this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о представителе компании '})
              this.item = this.getItemNew()
            })
        } else {
          this.item = this.getItemNew()
        }
      },
      fetchRights () {
        this.$store.dispatch('fetchRights', {AGENT_UPDATE: this.itemId, AGENT_DELETE: this.itemId, AGENT_RESET_PASSWORD: this.itemId})
      },
      editSignature () {
        forms.openEditor(this.item.signature).then(data => {
          this.item.signature = data
        })
      }
    }

  }

</script>




// WEBPACK FOOTER //
// ClientAgentForm.vue?c6420894